import { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { EVENT_OPTIONS } from "../content";
import { Reveal } from "./Reveal";

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
const EMPTY = { name: "", email: "", phone: "", event: EVENT_OPTIONS[0], athlete: "", notes: "", company: "" };

const Events = () => {
  const [form, setForm] = useState(EMPTY);
  const [state, setState] = useState("idle");
  const [message, setMessage] = useState("");

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !EMAIL_RE.test(form.email)) {
      setState("error");
      setMessage("Please add your name and a valid email address.");
      return;
    }
    setState("sending");
    setMessage("");
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ formType: "event", ...form }),
      });
      const body = await res.json().catch(() => ({}));
      if (!res.ok || body.ok !== true) throw new Error("failed");
      setState("success");
      setMessage("You're registered — we'll be in touch with details.");
      setForm(EMPTY);
    } catch {
      setState("error");
      setMessage("Something went wrong — please try again.");
    }
  };

  return (
    <section id="events" className="events section-pad" data-testid="events-section">
      <div className="events-panel">
        <Reveal className="section-head-center">
          <p className="eyebrow" data-testid="events-eyebrow">Gather</p>
          <h2 className="section-heading">Upcoming Events</h2>
          <p className="section-sub">Reserve your spot at our next Mindful Athlete workshop or event.</p>
        </Reveal>
        <Reveal delay={0.12}>
          <form className="events-form" noValidate onSubmit={submit} data-testid="event-registration-form">
            <div className="field">
              <label htmlFor="event-name">Full name *</label>
              <input id="event-name" type="text" required value={form.name} onChange={set("name")} data-testid="event-name-input" />
            </div>
            <div className="field">
              <label htmlFor="event-email">Email *</label>
              <input id="event-email" type="email" required value={form.email} onChange={set("email")} data-testid="event-email-input" />
            </div>
            <div className="field">
              <label htmlFor="event-phone">Phone (optional)</label>
              <input id="event-phone" type="tel" value={form.phone} onChange={set("phone")} data-testid="event-phone-input" />
            </div>
            <div className="field">
              <label htmlFor="event-select">Event</label>
              <select id="event-select" value={form.event} onChange={set("event")} data-testid="event-select">
                {EVENT_OPTIONS.map((option) => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
            </div>
            <div className="field">
              <label htmlFor="event-athlete">Athlete age / team (optional)</label>
              <input id="event-athlete" type="text" value={form.athlete} onChange={set("athlete")} data-testid="event-athlete-input" />
            </div>
            <div className="field field-full">
              <label htmlFor="event-notes">Notes / questions (optional)</label>
              <textarea id="event-notes" rows={4} value={form.notes} onChange={set("notes")} data-testid="event-notes-input" />
            </div>
            <input
              type="text"
              name="company"
              className="hp-field"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              value={form.company}
              onChange={set("company")}
              data-testid="event-honeypot"
            />
            <div className="field-full events-submit">
              <button type="submit" className="btn btn-primary" disabled={state === "sending"} data-testid="event-submit-button">
                {state === "sending" ? "Submitting..." : "Register"} <ArrowUpRight size={16} />
              </button>
              {message && (
                <p className={`form-status ${state === "error" ? "form-status-error" : "form-status-success"}`} role="status" data-testid="event-form-status">
                  {message}
                </p>
              )}
            </div>
          </form>
        </Reveal>
      </div>
    </section>
  );
};

export default Events;
